<template>
  <div class="grid-wrap">
		<div class="grid-row">
			<article class="push__bottom">
				<div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
					<BackLink/>
           <Section :section="this.sectionId" />
				</div>
				<Form 
					:error="$v.form.$error" 
					:formId="id" 
					:formErrorMessage="errorMessage"
					@submit="submitFormQuestion">
					<RadioList 
						:title="question" 
						:hintText="hintText"
            :hintTextHtml="hintTextHtml"
						:detailsTitle="detailsTitle"
						:detailsMessage="detailsMessage"
						:errorMessage="errorMessage"
						:validate="$v.form" 
						:id="id"
					>
						<div v-for="option in options" :key="'question' + option.id">
              <span class="hint" v-if="option.separator">or</span>
							<RadioButton :label="option.label" name="nss" :id="'question' + option.id" :value="option.id" :model="answer" @change="changeValue"/>
						</div>
					</RadioList>
				</Form>
				
			</article>
		</div>
	</div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { dataService } from "../shared";

export default {
  name: "home",
  props: {
    title: String
  },
  data() {
    return {
      id: "",
      sectionId: null,
      question: "",
      hintText: "",
      hintTextHtml: [],
      errorMessage: "All fields are required",
      detailsTitle: "",
      detailsMessage: "",
      name: "",
      options: [],
      answer: null,
      form: {
        id: null,
        label: null,
        url: null,
        response: null
      }
    };
  },
  created() {
    this.loadQuestion();
	},
	mounted() {
		this.loadAnswer()
	},
  validations: {
    form: {
      id: { required }
    }
  },
  methods: {
    changeValue: function(newValue) {
      this.answer = this.options[newValue].id;
      this.form.id = this.options[newValue].id;
      this.form.response = this.options[newValue].response;
      this.form.url = this.options[newValue].destination;
      this.form.label = this.options[newValue].label;
    },
    submitForm(form, valid) {
      valid.$touch();
      if (valid.$pending || valid.$error) {
				setTimeout(() => {
					document.querySelector(".error-summary__link").focus()
				}, 0);
				return;	
			}
      this.logResponse();
            if (dataService.canShowSummary())
            {
                this.$router.push({ name: "summary" });
            }
            else
            {
                this.$router.push({ name: form.url.toLowerCase() });
            }
    },
    submitFormQuestion() {
      this.submitForm(this.form, this.$v.form);
    },
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.id = currentQuestion.id;
      this.sectionId = currentQuestion.sectionId;
      this.question = currentQuestion.question;
      this.hintText = currentQuestion.hintText;
      this.hintTextHtml = currentQuestion.hintTextHtml;
      this.name = currentQuestion.responseId;
      this.options = currentQuestion.options;
      this.errorMessage = currentQuestion.errorMessage;
      this.detailsTitle = currentQuestion.detailsTitle;
      this.detailsMessage = currentQuestion.detailsMessage;
		},
		loadAnswer() {
			let previousResponse = dataService.wasAnsweredBefore(this.id);			
      if (previousResponse) {
				let radioButton = document.getElementById('question' + previousResponse.responseId);
				radioButton.checked = true;
				this.changeValue(previousResponse.responseId);
      }
		},
    logResponse() {
      let response = {
        id: this.id,
        questionType: "Radio",
        responseId: this.answer,
        response: this.form.response
      };
      dataService.logResponse(response);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>